export default __webpack_public_path__ + "static/media/IMG_5556.4d9bd2e2.jpg";